export const getColumn = (count: number) => {
  if (count === 1) {
    return 12;
  }
  if (count === 2) {
    return 6;
  }
  if (count === 3) {
    return 4;
  }
  if (count === 4) {
    return 6;
  }
  if (count === 5 || count === 6) {
    return 4;
  }
  if (count >= 7) {
    return 3;
  }

  return 12;
};
